import { render, staticRenderFns } from "./UpdateArea.vue?vue&type=template&id=4a1404d6&"
import script from "./UpdateArea.vue?vue&type=script&lang=js&"
export * from "./UpdateArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports